import SlimSelect from 'slim-select'

export default function() {
    document.querySelectorAll('.slim-select').forEach(select => {
        if(!select.classList.contains('js-country-selector')) {
            new SlimSelect({
                select: select,
                searchPlaceholder: ' ',
                placeholder: select.dataset?.placeholderText,
            });
        }
    });

    if(document.querySelector('.js-region-selector') && document.querySelector('.js-country-selector')) {
        let regionSelector = new SlimSelect({
            select: document.querySelector('.js-region-selector'),
            searchPlaceholder: ' ',
            placeholder: document.querySelector('.js-region-selector')?.options[0]?.getAttribute('data-text'),
        });

        regionSelector.disable();

        let countrySelector = new SlimSelect({
            select: document.querySelector('.js-country-selector'),
            searchPlaceholder: ' ',
            placeholder: document.querySelector('.js-country-selector').options[0].getAttribute('data-text'),
            onChange: handleCountrySelectChange
        });

        countrySelector.set(countrySelector.selected());

        function handleCountrySelectChange(info) {
            regionSelector.set(regionSelector.selected());

            if(!info.placeholder) {
                regionSelector.enable();

                let data = regionSelector.data.data;

                data.forEach( optgroup => optgroup.options ? optgroup.options.forEach( option => option.class = 'hidden') : '');

                data.filter( option => option.label === info.innerHTML)[0] ? data.filter( option => option.label === info.innerHTML)[0].options.forEach( option => option.class = '') : '';

                regionSelector.setData(data);
            }
        }
    }
    else if(document.querySelector('.js-country-selector')) {
        let countrySelector = new SlimSelect({
            select: document.querySelector('.js-country-selector'),
            searchPlaceholder: ' ',
            placeholder: document.querySelector('.js-country-selector').options[0].getAttribute('data-text'),
            onChange: handleCountryChange
        });

        countrySelector.set(countrySelector.selected());

        document.querySelectorAll('.regions').forEach( (region) => region.style.display = 'none')
        if(document.querySelector(`.regions-for-${countrySelector.data.data.find( (option) => option.selected).innerHTML}`)) {
            document.querySelector(`.regions-for-${countrySelector.data.data.find( (option) => option.selected).innerHTML}`).style.display = 'flex'
        }

        function handleCountryChange(info) {
            if(!info.placeholder) {
                document.querySelectorAll('.regions').forEach( (region) => region.style.display = 'none')
                document.querySelector(`.regions-for-${info.value}`).style.display = 'flex'
            }
        }
    }

}
